export default __webpack_public_path__ + "static/media/check_gray.be803327.svg";